import * as actionTypes from '../actions/allActionList';

const initialState = {
  events: [],
  startedFetchingEvents: false,
  doneFetchingEvents: false,
  failedToFetch: false,
  startedAddingEvent: false,
  doneAddingEvent: false,
  failedAddingEvent: false,
  startedEditingEvent: false,
  doneEditingEvent: false,
  failedEditingEvent: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STARTED_FETCHING_EVENTS:
      return {
        ...state,
        startedFetchingEvents: true,
        doneFetchingEvents: false,
        failedToFetch: false,
      };
    case actionTypes.FETCHED_EVENTS:
      return {
        ...state,
        startedFetchingEvents: false,
        doneFetchingEvents: true,
        events: action.events,
      };
    case actionTypes.FAILED_TO_FETCH_EVENTS:
      return {
        ...state,
        startedFetchingEvents: false,
        doneFetchingEvents: true,
        failedToFetch: true,
      };
    case actionTypes.STARTED_ADDING_EVENT:
      return {
        ...state,
        startedAddingEvent: true,
        doneAddingEvent: false,
        failedAddingEvent: false,
      };
    case actionTypes.ADDED_EVENT:
      return {
        ...state,
        startedAddingEvent: false,
        doneAddingEvent: true,
        events: action.events,
      };
    case actionTypes.FAILED_TO_ADD_EVENT:
      return {
        ...state,
        startedAddingEvent: false,
        doneAddingEvent: true,
        failedAddingEvent: true,
      };
    case actionTypes.EDITING_EVENT:
      return {
        ...state,
        startedEditingEvent: true,
        doneEditingEvent: false,
        failedEditingEvent: false,
      };
    case actionTypes.EDITED_EVENT:
      return {
        ...state,
        startedEditingEvent: false,
        doneEditingEvent: true,
        events: action.events,
      };
    case actionTypes.FAILED_TO_EDIT_EVENT:
      return {
        ...state,
        startedEditingEvent: false,
        doneEditingEvent: true,
        failedEditingEvent: true,
      };
    case actionTypes.RESET_EVENTS_DATA:
      return {
        ...state,
        startedEditingEvent: false,
        doneEditingEvent: false,
        failedEditingEvent: false,
      };
    default:
      return state;
  }
};

export default reducer;
